import {types} from "mobx-state-tree";

const Audit = types.model('Audit',{
  uuid: types.identifier,
  id: types.string,
  label: types.string,
})



export default Audit;
